// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mx-6";
export var imgContainer = "_mx-3";
export var menuIcon = "_mx-5";
export var pillWrapper = "_mx-2";
export var pillsContainer = "_mx-1";
export var subscriptionCard = "_mx-0";
export var subscriptionLogo = "_mx-4";